<template>
  <footer class="p-4" style="background-color: #161d3d;">
      <div class="container mx-auto px-4">
        <p class="text-sm text-center text-white" >© 2025 QREventos.com</p>
      </div>
  </footer>
</template>


<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>